import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../providers/api.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { SharedService } from '../../../providers/shared.service';

@Component({
  selector: 'sm-unblock-accounts',
  templateUrl: './unblock-accounts.component.html',
  styleUrls: ['./unblock-accounts.component.scss']
})
export class UnblockAccountsComponent implements OnInit {

  addDiscountForm : FormGroup;
  filteredList: any[] = []
formattedAddress: any = ''
entityHash: any = ''
  isMerchantSpecific:Boolean=false;
  isLocationSpecific:Boolean=false;
  isAllMerchant:Boolean=false;
  selectedMerchant:any=[];
  suggestedMerchant:any=[];
  isMerchantSelected:Boolean=false;
  entityList: any[] = [];
  objectoptions = [
    {name: 'angular'},
    {name: 'aise'}
  ]
  

  constructor(public dialog: MatDialogRef<UnblockAccountsComponent>, private _apiservice: ApiService, private router: Router,
    @Inject(MAT_DIALOG_DATA) public parentData: any, private sharedService: SharedService) { 
    this.addDiscountForm = new FormGroup({
      
      'description' : new FormControl(null,[Validators.required]),
      
  });


  }




  ngOnInit(): void {
    
 

  console.log(this.parentData);
  
    
    


    
  }

 

  deactivate(){


  let data = { 
    type: this.parentData.data.type,
    reason: this.addDiscountForm.value.description,
    status: 1,
    hashId: this.parentData.data.hash_id
 
 }
 console.log(data);

 this._apiservice.blockUnblockOperation(data)
 this.dialog.close();
 setTimeout(() => {
   this.sharedService.sendClickEvent();
 }, 1500);



   

      // console.log(this.entityList);
      
      // this._apiservice.createAndUpdateCoupon(data)
      // this.reloadCurrentRoute();
      // this.dialog.close();

      // this._apiservice.createAndUpdateCoupon(data)
      // this.reloadCurrentRoute();
      // this.dialog.close();
      // this.router.navigate(['/promotion', 'coupons'])
  



  }


 

  public closePopup(): void {
    this.dialog.close();
  }

  ngOnDestroy(): void {

  }
}
